export function tabs() {
    $('.tabs-holder .tabs-nav').on('click', 'a', function (e) {
        $('.tabs .image-holder').each(function (i, el) {
            if ($(el).find('iframe').length) {
                $(el).find('iframe')[0].contentWindow.postMessage('{"event":"command", "method":"pause","func":"' + 'pauseVideo' + '","args":""}', '*');
            }
        });
        let tab = $(this).parent();
        let tabIndex = tab.index();
        let tabPanel = $(this).closest('.tabs-holder');
        let tabPane = tabPanel.find('.tab').eq(tabIndex);
        tabPanel.find('.active').removeClass('active');
        tab.addClass('active');
        tabPane.addClass('active');
        e.preventDefault();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js